// @ts-nocheck
import { ReactComponent as Icon } from '../../assets/icons/appStore.svg';

export default function () {
  return <Icon className="MuiSvgIcon-root" alt="app-store" aria-label="App Store" />;
}
